module.exports = __webpack_public_path__ + "static/img/isFrom.8b54fab5.png";